import { type MessageKey } from 'types/LocaleMessageKey';

import { RingStyleEnum } from '@/app/enums/RingStyleEnum';

export interface RingCardData {
  alt: MessageKey;
  dataCyExplore: string;
  dataCyShop: string;
  hrefExplore: string;
  hrefShop: string;
  includeBgGradient: boolean;
  location: string;
  pdpAction: string;
  popAction: string;
  showFromPricing: boolean;
  src: string;
  style: RingStyleEnum;
  title: MessageKey;
}

const BASE_OR4_CARD_DATA: Omit<
  RingCardData,
  'hrefExplore' | 'hrefShop' | 'includeBgGradient' | 'src'
> = {
  alt: 'pdp_style_oura_ring_4',
  dataCyExplore: 'OR4Explore',
  dataCyShop: 'OR4Shop',
  location: 'homepage or4 module',
  pdpAction: 'go to or4 wizard',
  popAction: 'go to or4 pop',
  showFromPricing: true,
  style: RingStyleEnum.OuraRing4,
  title: 'oura_ring_4',
};

const OR4_CERAMIC_CARD_DATA: RingCardData = {
  alt: 'jade_pdp_midnight_primary_image_alt',
  dataCyExplore: 'OR4CeramicExplore',
  dataCyShop: 'OR4CeramicShop',
  hrefExplore: '/store/rings/oura-ring-4-ceramic',
  hrefShop: '/store/rings/oura-ring-4-ceramic/midnight',
  includeBgGradient: true,
  location: 'homepage or4 ceramic module',
  pdpAction: 'go to or4 ceramic wizard',
  popAction: 'go to or4 ceramic pop',
  showFromPricing: false,
  src: '/blue-sky/home/home-ring-module-or4-ceramic.jpg?ar=10:7&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.42&fp-z=2',
  style: RingStyleEnum.Ceramic,
  title: 'oura_ring_4_ceramic',
};

const useRingCardData = (): RingCardData[] => {
  return [
    {
      ...BASE_OR4_CARD_DATA,
      alt: 'pdp_style_oura_ring_4',
      hrefExplore: '/store/rings',
      hrefShop: '/store/rings/oura-ring-4/silver',
      includeBgGradient: true,
      src: 'blue-sky/home/home-ring-module-or4.jpg?ar=10:7&fit=crop&crop=focalpoint&fp-x=0.55&fp-y=0.36&fp-z=1.9',
    },
    OR4_CERAMIC_CARD_DATA,
  ];
};

export default useRingCardData;
